<template>
  <div class="dialog">
    <div class="dialog-header">{{ ts('FAVOURITE')['FAVOURITE'] }}</div>
    <div class="dialog-content">
      <div class="favorites">
        <el-tabs v-model="dataType" @tab-click="handleClick" class="tabs" :stretch="true">
          <el-tab-pane v-for="tab in categories" :key="tab.name" :label="tab.name" :name="tab.value"> </el-tab-pane>
        </el-tabs>
        <div class="fav-list" v-if="list.length > 0">
          <div class="hotel-list" v-if="dataType == 2">
            <HotelItem :list="list" />
          </div>
          <div class="activity-list room-list" v-else-if="dataType == 3">
            <RoomItem :list="list" />
          </div>
          <div class="activity-list" v-else :class="{ 'product-list': dataType == 11, 'service-list': dataType == 13 }">
            <ProductItem v-for="(item, index) in list" :key="index" type="readonly" :item="item" :parentId="item.pageId" />
          </div>
        </div>
        <el-empty :image-size="200" v-else></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { LanguagePackage } from '@/mixins/LanguagePackage'
import HotelItem from '@/components/HotelItem.vue'
import RoomItem from '@/components/RoomItem.vue'
import ProductItem from '@/components/ProductItem.vue'

export default {
  name: 'favList',
  mixins: [LanguagePackage],
  components: {
    HotelItem,
    RoomItem,
    ProductItem,
  },
  data() {
    return {
      categories: [
        {
          name: 'Hotel',
          value: '2',
        },
        {
          name: 'Room Type',
          value: '3',
        },
        {
          name: 'Product',
          value: '11',
        },
        {
          name: 'Service',
          value: '13',
        },
        {
          name: 'Activity',
          value: '12',
        },
      ],
      list: [],
      dataType: '2',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 收藏列表
    getList() {
      // dataType 酒店 2，房型 3，商品 11，活动 12，服务 13
      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.list = []
      getAction(`/user/api/collections`, {
        type: this.dataType,
        pageNo: 1,
      })
        .then((res) => {
          loading.close()
          if (res.result) {
            this.list = res.result
          } else {
            this.list = []
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    handleClick(tab, event) {
      this.getList()
    },
  },
}
</script>

<style scoped lang="scss">
.tabs {
  padding: 0 40px;
}
</style>
